import { render, staticRenderFns } from "./CaptureNewDealNote.vue?vue&type=template&id=3b78e36e&scoped=true"
import script from "./CaptureNewDealNote.vue?vue&type=script&lang=js"
export * from "./CaptureNewDealNote.vue?vue&type=script&lang=js"
import "./CaptureNewDealNote.vue?vue&type=style&index=0&id=3b78e36e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b78e36e",
  null
  
)

export default component.exports